import styled from "styled-components";

export const GoldenLine = styled.span`
  display: block;
  width: 8rem;
  height: 4px;
  background-color: var(--primaryColor);
  margin: 0 auto 5rem;
`;
